import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SeverityBadge } from "@/lib/severity";

function StatusPill({ status }) {
  const s = (status || "").toLowerCase();
  const color =
    s === "closed" || s === "recovered"
      ? "bg-green-100 text-green-700 border-green-200"
      : s === "close monitoring"
      ? "bg-amber-100 text-amber-700 border-amber-200"
      : "bg-orange-100 text-orange-700 border-orange-200";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider border ${color}`}>
      {status || "Open"}
    </span>
  );
}

export default function RecentEventsTable({ items = [], total }) {
  const fmtTime = (r) => {
    const d = r.tanggal || "";
    const w = r.waktu || "";
    return d ? `${d} ${w}` : "";
  };
  return (
    <div>
      <div className="overflow-x-auto trams-scroll">
        <table className="w-full text-sm" data-testid="recent-events-table">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-slate-500 border-b border-slate-200">
              <th className="text-left font-semibold pb-3">Time</th>
              <th className="text-left font-semibold pb-3">Line / Train ID</th>
              <th className="text-left font-semibold pb-3">Subsystem</th>
              <th className="text-left font-semibold pb-3">Failure Mode</th>
              <th className="text-left font-semibold pb-3">Impact</th>
              <th className="text-right font-semibold pb-3">Delay (Min)</th>
              <th className="text-center font-semibold pb-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={7} className="text-center py-6 text-slate-400 text-xs">No events in the selected filter.</td></tr>
            )}
            {items.map((r) => (
              <tr key={r.id} className="border-b border-slate-100 hover:bg-slate-50/50">
                <td className="py-3 text-slate-700 whitespace-nowrap">{fmtTime(r)}</td>
                <td className="py-3 text-slate-700">{r.no_ts ? `T-${r.no_ts}` : "—"}</td>
                <td className="py-3 text-slate-700">{r.equipment || "—"}</td>
                <td className="py-3 text-slate-900 font-medium max-w-[240px] truncate" title={r.kejadian}>{r.kejadian || "—"}</td>
                <td className="py-3 text-xs"><SeverityBadge value={r.dampak} /></td>
                <td className="py-3 text-right tabular-nums text-slate-900 font-semibold">{r.delay_seconds ? Math.round(r.delay_seconds / 60) : 0}</td>
                <td className="py-3 text-center"><StatusPill status={r.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-between mt-3 text-xs">
        <span className="text-slate-500">Showing 1 to {items.length} of {total?.toLocaleString() || items.length} events</span>
        <Link to="/events" className="text-[#1e40af] font-semibold flex items-center hover:underline" data-testid="view-all-events">
          View all events <ArrowRight className="w-3.5 h-3.5 ml-1" />
        </Link>
      </div>
    </div>
  );
}
